import { AlertTriangle, Target, Zap } from 'lucide-react'

/** Number of questions to display per page before "Load More" */
export const QUESTIONS_PER_PAGE = 50

/** Solution type icons and colors for approach badges */
export const SOLUTION_TYPE_CONFIG: Record<
  string,
  { icon: typeof AlertTriangle; color: string; label: string }
> = {
  brute: { icon: AlertTriangle, color: 'text-orange-400', label: 'Brute' },
  acceptable: { icon: Target, color: 'text-sky-400', label: 'Acceptable' },
  optimal: { icon: Zap, color: 'text-emerald-400', label: 'Optimal' },
}

/** Column labels for visibility dropdown and context menu */
export const COLUMN_LABELS: Record<string, string> = {
  externalId: 'External ID',
  name: 'Name',
  difficulty: 'Difficulty',
  premiumRequired: 'Premium',
  tags: 'Tags',
  acceptanceRate: 'Accept %',
  source: 'Source',
  studyPlans: 'Study Plans',
  editorialUrl: 'Editorial',
  doneBefore: 'Done',
  addHomework: 'Add',
}

/** Reorderable column list for the dropdown */
export const REORDERABLE_COLUMNS = [
  { id: 'externalId', label: 'External ID' },
  { id: 'name', label: 'Name' },
  { id: 'difficulty', label: 'Difficulty' },
  { id: 'doneBefore', label: 'Done', clientOnly: true },
  { id: 'addHomework', label: 'Add', clientOnly: true },
  { id: 'premiumRequired', label: 'Premium' },
  { id: 'tags', label: 'Tags' },
  { id: 'acceptanceRate', label: 'Accept %' },
  { id: 'source', label: 'Source' },
  { id: 'editorialUrl', label: 'Editorial' },
] as const

/** Default column order (without client-specific columns) */
export const DEFAULT_COLUMN_ORDER = [
  'externalId',
  'name',
  'difficulty',
  'premiumRequired',
  'tags',
  'acceptanceRate',
  'source',
  'studyPlans',
  'editorialUrl',
  'delete',
] as const

/** Default column order for client context (with client-specific columns) */
export const CLIENT_COLUMN_ORDER = [
  'addHomework',
  'doneBefore',
  'externalId',
  'name',
  'difficulty',
  'tags',
  'studyPlans',
  'editorialUrl',
  'premiumRequired',
  'acceptanceRate',
  'source',
  'delete',
] as const

/** Difficulty options for filtering */
export const DIFFICULTY_OPTIONS = ['Easy', 'Medium', 'Hard'] as const

/** Default hidden columns */
export const DEFAULT_HIDDEN_COLUMNS = {
  premiumRequired: false,
  acceptanceRate: false,
  externalId: false,
  source: false,
} as const
